<template>
    <div class="m_pad max-w-screen-xl mx-auto" role="main">
        <h1 class="mx-auto py-2 text-left text-4xl font-bold">{{ $t('Home.FilingWorkflow.Heading') }}</h1>
        <p class="text-xl py-2 mx-auto text-left" id="breadcrumb">{{ $t('Template.Breadcrumb', { breadcrumb: nav }) }}</p>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="standard-filing-workflow-button"
                :aria-label="$t(`Home.FilingWorkflow.StandardFilingWorkflowButton.Name`) + ' ' + $t(`Home.FilingWorkflow.StandardFilingWorkflowButton.Description`)"
                @click="filingWorkflowSelection(FilingWorkflow.Standard)">
                <p class="button-header">{{ $t(`Home.FilingWorkflow.StandardFilingWorkflowButton.Name`) }}</p>
                <p class="button-info">{{ $t(`Home.FilingWorkflow.StandardFilingWorkflowButton.Description`) }}</p> 
            </button>
        </div>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="amendment-filing-workflow-button"
                :aria-label="$t(`Home.FilingWorkflow.AmendmentFilingWorkflowButton.Name`) + ' ' + $t(`Home.FilingWorkflow.AmendmentFilingWorkflowButton.Description`)"
                @click="filingWorkflowSelection(FilingWorkflow.Amendment)">
                <p class="button-header">{{ $t(`Home.FilingWorkflow.AmendmentFilingWorkflowButton.Name`) }}</p>
                <p class="button-info">{{ $t(`Home.FilingWorkflow.AmendmentFilingWorkflowButton.Description`) }}</p> 
            </button>
        </div>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="renewal-filing-workflow-button"
                :aria-label="$t(`Home.FilingWorkflow.RenewalFilingWorkflowButton.Name`) + ' ' + $t(`Home.FilingWorkflow.RenewalFilingWorkflowButton.Description`)"
                @click="filingWorkflowSelection(FilingWorkflow.Renewal)">
                <p class="button-header">{{ $t(`Home.FilingWorkflow.RenewalFilingWorkflowButton.Name`) }}</p>
                <p class="button-info">{{ $t(`Home.FilingWorkflow.RenewalFilingWorkflowButton.Description`) }}</p> 
            </button>
        </div>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="abandoment-filing-workflow-button"
                :aria-label="$t(`Home.FilingWorkflow.AbandonmentFilingWorkflowButton.Name`) + ' ' + $t(`Home.FilingWorkflow.AbandonmentFilingWorkflowButton.Description`)"
                @click="filingWorkflowSelection(FilingWorkflow.Abandonment)">
                <p class="button-header">{{ $t(`Home.FilingWorkflow.AbandonmentFilingWorkflowButton.Name`) }}</p>
                <p class="button-info">{{ $t(`Home.FilingWorkflow.AbandonmentFilingWorkflowButton.Description`) }}</p> 
            </button>
        </div>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="withdrawal-filing-workflow-button"
                :aria-label="$t(`Home.FilingWorkflow.WithdrawalFilingWorkflowButton.Name`) + ' ' + $t(`Home.FilingWorkflow.WithdrawalFilingWorkflowButton.Description`)"
                @click="filingWorkflowSelection(FilingWorkflow.Withdrawal)">
                <p class="button-header">{{ $t(`Home.FilingWorkflow.WithdrawalFilingWorkflowButton.Name`) }}</p>
                <p class="button-info">{{ $t(`Home.FilingWorkflow.WithdrawalFilingWorkflowButton.Description`) }}</p> 
            </button>
        </div>
        <div class="mx-auto py-2 main-controls">
            <NavigationControls 
                :showBackButton="true"
                :showHelpButton="true" 
                @openHelp="openHelp()" 
                @previousPage="previousPage()"/>
            <Help 
                :page="0" 
                v-show="isHelpVisible" 
                @closeHelp="closeHelp()"/>
        </div>          
    </div>           
</template>

<script>

import { AppHasData, FilingWorkflow } from '../../assets/constants.js'
import NavigationControls from '../common/NavigationControls.vue'
import Help from '../common/Help.vue'
export default {
    name: 'FilingWorkflow',
    components: {
        NavigationControls,
        Help
    },
    data: () => ({
        nav:'',
        FilingWorkflow: FilingWorkflow,
        fbnFiling: {},
        isHelpVisible: false
    }),
    methods: {
        filingWorkflowSelection (workflow) {
            this.fbnFiling = this.$store.getters.getFbnFiling
            this.fbnFiling.workflow = workflow
            this.$store.dispatch('setFbnFiling', this.fbnFiling)           
            this.$store.dispatch('setWorkflow', workflow);
            this.$store.dispatch('setSubheader', workflow);         
            this.$store.dispatch('setFilingSelectionType', workflow);
            if (workflow === FilingWorkflow.Standard) {
                this.$router.push('fbnsearch');
            } else {
                this.$store.dispatch('setWorkflow', workflow);
                this.$router.push('fbnlookup');
            };
        },
        openHelp () {
            this.isHelpVisible = true
        },
        closeHelp () {
            this.isHelpVisible = false
        },
        previousPage () {
            this.$router.push('fbnfilingapproach')
        }
    },
    beforeMount () {
        this.nav = this.$store.getters.getSubheader;
        AppHasData(this.$store.getters.getAppHasData, this)
        window.scrollTo(0,0)
    }
};

</script>

<style scoped>

    .max-w-100 {
        width: 100%;
    }

    p {
        line-height: 1.65em !important;
    }

</style>
